const $doc = $(document);

$doc.on('change', '.qty', function() {
  const $this = $(this);
  const $row = $this.closest('tr');
  const bundlemain = $row.data('bundlemain');
  const bundledno = $row.data('bundledno');
  const $cart = $('.table-cart');

  if(bundlemain) {
    const qty = parseInt($(this).val());
    const name = $this
      .attr('name');
    let data = name + '=' + qty;

    $cart.find('.line-item.hidden').each(function(){
      let _bundledno = $(this).data('bundledno');
      if(bundledno == _bundledno) {
        const _name = $(this)
          .find('td.table__quantity .qty')
          .attr('name');
        const qty_times = $(this).data('qty-times');
        let _data = _name + '=' + qty * qty_times;

        $.ajax({
          url: '/cart/update.js',
          type: 'POST',
          dataType: 'JSON',
          data: _data,
          async: false
        }).done(function(data) {

        });
      }
    });

    $.ajax({
      url: '/cart/update.js',
      type: 'POST',
      dataType: 'JSON',
      data: data,
    }).done(function(data) {
      $('.cart-count').html(data.item_count);

      $.ajax({
        url: '/cart'
      }).done(function(data) {
        $('.form-cart').html(
          $(data)
            .find('.form-cart')
            .html()
        );

        hideBundledItems();
      });
    });
  } else {

    const id = $this
      .attr('name')
      .split('updates[')[1]
      .split(']')[0];

    $.ajax({
      url: '/cart/update.js',
      type: 'POST',
      dataType: 'JSON',
      data: `${$this.attr('name')}=${$this.val()}`
    }).done(function(data) {
      if (data.item_count == 0) {
        $.ajax({
          url: '/cart'
        }).done(function(data) {
          $('.form-cart').html(
            $(data)
              .find('.form-cart')
              .html()
          );
        });
      } else {
        // Get base values
        const $tableTotal = $row.find('.table__total');
        const compareAt = Shopify.products[id].compare_at;
        const price = Shopify.products[id].price;

        const priceDiff = compareAt - price;

        // Get product data
        const item = data.items.filter(item => item.id == id);

        // Get quantities
        const qtyOld = $row.data('qty');
        const qtyNew = item[0] ? item[0].quantity : 0;

        // Get discounts
        const discountOld = Shopify.products.total_sale;
        const discountNew = discountOld - priceDiff * qtyOld + priceDiff * qtyNew;

        // Get new total price
        const totalNew = data.total_price;

        // Set new values
        $row.data('qty', qtyNew);
        Shopify.products.total_sale = discountNew;

        if ($this.val() == 0) {
          $row.slideUp().remove();

          if (discountNew <= 0) {
            $('.order-block__discount').remove();
          }
        }

        $('.order-block__total .price').html(Shopify.formatMoney(totalNew));
        $('.order-block__discount .price').html(Shopify.formatMoney(discountNew));
        $('.order-block__subtotal .price').html(Shopify.formatMoney(totalNew + discountNew));

        if (compareAt != price) {
          $tableTotal.find('del .money').html(Shopify.formatMoney(qtyNew * compareAt, Shopify.current_format));

          $tableTotal.find('ins .money').html(Shopify.formatMoney(qtyNew * price, Shopify.current_format));

          $tableTotal.find('small').html(`(${Shopify.formatMoney(priceDiff * qtyNew)})`);
        } else {
          $tableTotal.find('.money').html(Shopify.formatMoney(qtyNew * price, Shopify.current_format));
        }
      }

      $('.cart-count').html(data.item_count);
    });
  }
});

$doc.on('click', '.qty-wrapper span', function() {
  var $this = $(this);
  // var qtyName = $this
  //   .parent()
  //   .find('input')
  //   .attr('name');
  // var qtyInput = $(`[name="${qtyName}"]`);
  var qtyInput = $this.siblings('input');
  var qtyInputVal = qtyInput.val();
  qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;

  if ($this.hasClass('qty-plus')) {
    qtyInputVal++;
    qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
  } else {
    qtyInputVal--;
    qtyInputVal = qtyInputVal < 0 ? 0 : qtyInputVal;
  }
  qtyInput.val(qtyInputVal).trigger('change');
});

$doc.on('click', '.form-cart .line-item a.remove', function() {
  const $row = $this.closest('tr');
  const bundlemain = $row.data('bundlemain');
  const bundledno = $row.data('bundledno');
  const $cart = $('.table-cart');

  const qty = 0;
  const name = $row
    .find('td.table__quantity .qty')
    .attr('name');
  let data = name + '=' + qty;

  if(bundlemain) {
    $cart.find('.line-item.hidden').each(function(){
      let _bundledno = $(this).data('bundledno');
      if(bundledno == _bundledno) {
        const _name = $(this)
          .find('td.table__quantity .qty')
          .attr('name');
        let _data = _name + '=' + qty;

        $.ajax({
          url: '/cart/update.js',
          type: 'POST',
          dataType: 'JSON',
          data: _data,
          async: false
        }).done(function(data) {

        });
      }
    });
  }

  $.ajax({
    url: '/cart/update.js',
    type: 'POST',
    dataType: 'JSON',
    data: data
  }).done(function(data) {
    location.href = '/cart'
  });
});

function stripPrice(str) {
  return parseFloat(str.replace('$',''));
}

// hide bundled items
function hideBundledItems() {
  let $cart = $('.table-cart');
  if($cart.length > 0) {
    $cart.find('.line-item:not(.hidden)').each(function(){
      let bundlemain = $(this).data('bundlemain');
      let bundledno = $(this).data('bundledno');
      let qty = parseInt($(this).find('td.table__quantity .qty').val());
      let price = stripPrice($(this).find('td.table__price').text());
      let total = stripPrice($(this).find('td.table__total .price__amount .money').text());
      if(bundlemain) {
        // properties
        let properties = [];
        let add_properties = '';
        $(this).find('.table__properties span').each(function(){
          let p_label = $(this).text().split(':')[0];
          if(!properties.includes(p_label)) {
            properties.push(p_label);
          }
        });

        $cart.find('.line-item.hidden').each(function(){
          let _bundledno = $(this).data('bundledno');
          if(bundledno == _bundledno) {
            let _qty = parseInt($(this).find('td.table__quantity .qty').val());
            let qty_times = _qty / qty;
            $(this).data('qty-times', qty_times);
            price += stripPrice($(this).find('td.table__price').text()) * qty_times;
            total += stripPrice($(this).find('td.table__total .price__amount .money').text());

            const product_name = $(this).find('td.table__name a.table__product').text();
            const variant_name = $(this).find('td.table__name p.table__variant').text();
            if(!properties.includes(product_name)) {
              let new_prop = '<span>' + product_name + ': ' + variant_name;
              if(qty_times > 1) {
                new_prop += ' * ' + qty_times;
              }
              new_prop += '</span>';
              add_properties += new_prop;
            }
          }
        });

        $(this).find('.table__properties').prepend(add_properties);
      }

      $(this).find('td.table__price').text('$' + price);
      $(this).find('td.table__total .price__amount .money').text('$' + total);
      $(this).find('td.table__name .price__amount .money').text('$' + total);
    });
  }
}

$doc.ready(function(){
  hideBundledItems();
});







// WEBPACK FOOTER //
// ../assets/js/cart.js